angular.module('app.services').factory('userService', [
  '$q',
  '$http',
  '$location',
  '$window',
  'UserServiceApi',
  'SharedApi',
  'api',
  'socket',
  function userService(
    $q,
    _$http,
    $location,
    $window,
    UserServiceApi,
    SharedApi,
    api,
    socket
  ) {
    const defaultRoutes = {
      admin: '/admin/admin-listings',
      candidate: '/matches',
      newUser: '/profile',
    }

    socket.on('USER_ROLE_UPDATED', async data => {
      const user = await instance.getUser()
      if (user.id === data) {
        instance.refreshUser(user)
      }
    })

    let instance = {
      getUser: async () => {
        const user = JSON.parse($window.localStorage.getItem('user'))
        console.debug('userService.getUser:', user)
        if (user) return user
        const currentPath = $location.path()
        console.debug('currentPath is', currentPath)
        const firstPartOfPath = currentPath.split('/')[1]
        const publicRoutes = [
          'signin',
          'signup',
          'forgot',
          'invite-friends',
          'get-in-touch',
          'about',
          'blog',
          'faqs',
          'terms-conditions',
          'pause',
          'privacy-policy',
          'unsubscribe',
        ]

        const isPublicRoute =
          currentPath === '' ||
          currentPath === '/' ||
          publicRoutes.includes(firstPartOfPath)

        if (!user && !isPublicRoute) {
          console.debug('No user found for private page, redirecting to signin')
          $location.path('/signin')
          return false
        }
      },
      verifySession: async () => {
        const userData = $window.localStorage.getItem('user')
        const user = userData ? JSON.parse(userData) : undefined
        if (user && api.verifySessionToken()) {
          return user
        }

        if (user && !api.verifySessionToken()) {
          const sessionRefreshed = await api.refreshSession()
          if (sessionRefreshed) {
            return user
          }

          return instance.endSessionRedirect()
        }
      },
      getUserPromise: () => {
        const user = JSON.parse($window.localStorage.getItem('user', user))
        return new Promise((resolve, _reject) => {
          if (user) {
            resolve($q.when(user))
          }
        })
      },
      refreshUser: async user => {
        const currentDefaultRoute = user.defaultRoute
        const {data: userData} = await SharedApi.getUserById(user.id)
        const updatedUser = await instance.setUser(userData)
        if (currentDefaultRoute !== updatedUser.defaultRoute) {
          $window.location.href = updatedUser.defaultRoute
        }

        return updatedUser
      },
      setUser: async user => {
        // TODO: Permissions
        if (user.roles.find(role => role.id === 'admin')) {
          user.defaultRoute = defaultRoutes.admin
          user.isAdmin = true
          user.type = 'admin'
        } else if (user.roles.find(role => role.id === 'agent')) {
          user.defaultRoute = defaultRoutes.admin
          user.isAdmin = true
          user.type = 'agent'
        } else if (user.roles.find(role => role.id === 'ops')) {
          user.defaultRoute = defaultRoutes.admin
          user.isAdmin = true
          user.type = 'ops'
        } else if (user.roles.find(role => role.id === 'intern')) {
          user.defaultRoute = defaultRoutes.admin
          user.isAdmin = true
          user.type = 'intern'
        } else if (user.roles.find(role => role.id === 'position-creator')) {
          user.defaultRoute = defaultRoutes.admin
          user.isAdmin = true
          user.type = 'position-creator'
        } else if (
          user.roles.find(role => role.id === 'position-creator-inhouse')
        ) {
          user.defaultRoute = defaultRoutes.admin
          user.isAdmin = true
          user.type = 'position-creator-inhouse'
        } else if (
          user.roles.length === 1 &&
          user.roles.find(role => role.id === 'user')
        ) {
          user.defaultRoute = defaultRoutes.newUser
          user.isNewUser = true
        } else if (
          user.roles.find(role => role.id === 'candidate') &&
          !user.roles.find(role => role.id === 'approved')
        ) {
          user.defaultRoute = defaultRoutes.newUser
          user.isNewUser = true
        } else if (
          user.roles.find(role => role.id === 'candidate') &&
          user.roles.find(role => role.id === 'approved')
        ) {
          user.defaultRoute = defaultRoutes.candidate
          user.isCandidate = true
        }

        // TODO: add candidate role when sign up?
        if (user.isCandidate) {
          try {
            const {data: agent} = await UserServiceApi.getUserAssignedAgent(
              user.id
            )
            user.agent = agent

            // TODO: get approval status of candidate if rejected then defaultRoute will be matches
          } catch (error) {
            console.error(`Error loading user agent: ${error}`)
            user.agent = undefined
          }
        }
        // TODO: profile picture

        $window.localStorage.setItem('user', JSON.stringify(user))
        return user
      },
      destroyUser: () => {
        // eslint-disable-next-line unicorn/no-null
        $window.localStorage.setItem('user', null)
      },
      endSessionRedirect: () => {
        instance.destroyUser()
        $location.path('/signin')
        return false
      },
      authenticateRoute: route => {
        return instance.getUser().then(user => {
          const deferred = $q.defer()
          if (route.roles && route.roles.length > 0) {
            if (user) {
              const commonRoles = user.roles.filter(role =>
                route.roles.includes(role.id)
              )
              if (commonRoles.length === 0) {
                deferred.reject({
                  reason: 403,
                  redirectTo: user.defaultRoute,
                })
              }
            }

            if (!user) {
              deferred.reject({
                reason: 403,
                redirectTo: '/signin',
              })
            }
          }

          if (user && route.hideWhenSession) {
            deferred.reject({
              reason: 403,
              redirectTo: user.defaultRoute,
            })
          }

          deferred.resolve(user)
          return deferred.promise
        })
      },
    }

    return instance
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/services/user-service.js